import { Link } from "react-router-dom";
import {
    ShieldCheck,
    Users,
    Cable,
    HeartHandshake,
    ArrowRight,
} from "lucide-react";
import { PageHeader, FadeUp } from "../components/Reveal";
import { IMAGES } from "../data/siteData";

const VALUES = [
    { icon: ShieldCheck, label: "15+ Years of Trust" },
    { icon: Users, label: "Trusted by NRT’ians" },
    { icon: Cable, label: "Reliable FTTH Connectivity" },
    { icon: HeartHandshake, label: "Customer-Focused Service" },
];

export default function About() {
    return (
        <>
            <PageHeader
                testId="about-header"
                eyebrow="ABOUT US"
                title={
                    <>
                        Connecting Narasaraopet for{" "}
                        <span className="text-gradient-fire">15+ Years</span>
                    </>
                }
                subtitle="Eway Fiber Net has been serving NRT’ians for more than 15 years, providing reliable fiber connectivity and entertainment solutions for homes and businesses."
            />

            <section className="mx-auto max-w-7xl px-4 pb-24 sm:px-6 lg:px-8">
                <div className="grid items-center gap-12 lg:grid-cols-2">
                    <FadeUp>
                        <div className="relative">
                            <div
                                className="pointer-events-none absolute -inset-6 rounded-[3rem] bg-[#E61C24]/12 blur-3xl"
                                aria-hidden="true"
                            />
                            <div className="relative overflow-hidden rounded-[2rem] border border-white/12 shadow-[0_30px_80px_rgba(0,0,0,0.55)]">
                                <img
                                    src={IMAGES.familyTv}
                                    alt="A family in Narasaraopet enjoying fiber internet and TV at home"
                                    className="aspect-[4/3] w-full object-cover"
                                    loading="lazy"
                                />
                                <div className="absolute inset-0 bg-gradient-to-t from-[#0B0F19]/80 via-transparent to-transparent" />
                                <div className="glass absolute bottom-5 left-5 right-5 rounded-2xl p-4">
                                    <p className="font-mono text-[10px] font-bold tracking-[0.28em] text-[#00F0FF]">
                                        LOCAL · RELIABLE · PREMIUM
                                    </p>
                                    <p className="font-display mt-1 text-lg font-bold text-white">
                                        Your neighbourhood fiber network
                                    </p>
                                </div>
                            </div>
                            <div className="glass absolute -right-4 -top-6 hidden rotate-3 rounded-2xl p-4 shadow-xl sm:block">
                                <p className="font-mono text-2xl font-black text-gradient-fire">
                                    99.9%
                                </p>
                                <p className="text-xs font-semibold text-slate-300">
                                    Network Uptime
                                </p>
                            </div>
                        </div>
                    </FadeUp>

                    <div>
                        <FadeUp delay={0.1}>
                            <p className="text-base leading-relaxed text-slate-300 sm:text-lg">
                                From the first fiber line to thousands of streaming
                                evenings, Eway Fiber Net has grown alongside
                                Narasaraopet. We are a local team — your neighbours —
                                building connectivity you can count on every single
                                day.
                            </p>
                        </FadeUp>
                        <div className="mt-9 grid grid-cols-1 gap-4 sm:grid-cols-2">
                            {VALUES.map((v, i) => (
                                <FadeUp key={v.label} delay={0.15 + i * 0.06}>
                                    <div
                                        data-testid={`about-value-${v.label.toLowerCase().replace(/[^a-z0-9]+/g, "-")}`}
                                        className="glass flex items-center gap-3.5 rounded-2xl p-4 transition-[border-color,transform] duration-200 hover:-translate-y-0.5 hover:border-[#00F0FF]/40"
                                    >
                                        <span className="flex h-10 w-10 shrink-0 items-center justify-center rounded-xl bg-[#E61C24]/15 text-[#ff5a60]">
                                            <v.icon className="h-5 w-5" />
                                        </span>
                                        <span className="text-sm font-bold text-white">
                                            {v.label}
                                        </span>
                                    </div>
                                </FadeUp>
                            ))}
                        </div>
                        <FadeUp delay={0.35}>
                            <Link
                                to="/get-connected"
                                data-testid="about-cta"
                                className="group mt-10 inline-flex items-center gap-3 rounded-full bg-[#E61C24] px-8 py-4 text-base font-extrabold text-white shadow-[0_10px_44px_rgba(230,28,36,0.5)] transition-[transform,background-color] duration-200 hover:scale-105 hover:bg-[#C7151C]"
                            >
                                Join the Eway Family
                                <ArrowRight className="h-5 w-5 transition-transform duration-200 group-hover:translate-x-1" />
                            </Link>
                        </FadeUp>
                    </div>
                </div>
            </section>
        </>
    );
}
